<h3>cps-content-page - CpsContentPageComponent</h3>

<a [routerLink]="['/login']">Back</a>

<router-outlet></router-outlet>